import { netsparkAxios } from 'core/services/HTTPService';

import getStatesUrl from './apiUrls';

const getStates = (signal) => netsparkAxios.get(getStatesUrl, { signal });

export default getStates;
